import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from "@sentry/react";
import App from './App';
import {GlobalProvider} from './contexts/GlobalContext';
// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

Sentry.init({
    dsn: "https://40a5b7fed8c37d3c843af024a41a372f@o4507624473559040.ingest.us.sentry.io/4507624478670848",
    integrations: [],
});

window.addEventListener('error', (event) => {
    try {
        const debug = {
            ts: new Date().toISOString(),
            type: 'window.error',
            message: event?.message,
            filename: event?.filename,
            lineno: event?.lineno,
            colno: event?.colno,
            stack: event?.error?.stack,
            url: window.location.href,
        };
        console.error('[global][window.error]', debug);
        window.__lastGlobalError = debug;
        try { sessionStorage.setItem('lastGlobalError', JSON.stringify(debug)); } catch (_) { /* ignore */ }
    } catch (_) { /* ignore */ }
});

window.addEventListener('unhandledrejection', (event) => {
    try {
        const reason = event?.reason;
        const debug = {
            ts: new Date().toISOString(),
            type: 'unhandledrejection',
            message: reason?.message || String(reason),
            stack: reason?.stack,
            url: window.location.href,
        };
        console.error('[global][unhandledrejection]', debug);
        window.__lastGlobalError = debug;
        try { sessionStorage.setItem('lastGlobalError', JSON.stringify(debug)); } catch (_) { /* ignore */ }
    } catch (_) { /* ignore */ }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <GlobalProvider>
                <App />
            </GlobalProvider>
        </BrowserRouter>
    </React.StrictMode>
);
